<template>
  <div class="mall-user-search-box">
    <div class="mall-user-search">
      <div class="search">
        <div class="avater-part" role="button" @click="goMyCenter">
          <img class="avater" :src="avatar" alt="个人中心" />
          <template v-if="rightsInterestsConfig && rightsInterestsConfig.isOpen">
            <span></span>
            <i>权益</i>
          </template>
        </div>
        <Search
          v-if="storeConfig && storeConfig.name"
          :storeConfig="storeConfig"
          searchFrom="index"
          position-type=""
          background-type="transparent"
          :is-index="isIndex"
        ></Search>

        <!-- 搜索结果层 -->
        <div class="set-part" role="button" v-if="userAgent.midasAPP" @click="goToAppSettings">
          <img src="../../../ui/assets/mobile/images/set.svg" alt="设置" class="set-img" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex"
import Search from "./Search.vue"
import * as reportDict from "../../constants/report-dictonary"
import * as userApi from "@api/user"

export default {
  props: ["storeConfig", "isIndex"],

  components: {
    Search
  },
  data() {
    return {
      rightsInterestsConfig: ""
    }
  },
  computed: {
    ...mapGetters(["avatar", "loginState", "userAgent", "pf"]),
    ...mapState({
      userJifen: ({ user }) => user.jifen
    })
  },
  created() {
    this.getRightsInterests()
  },
  methods: {
    ...mapActions(["reportUserAction", "showAppLogin", "reportAndJump"]),

    goToAppSettings() {
      this.$router.push("/app-settings")
    },

    /**
     * 去个人中心
     */
    goMyCenter() {
      if (this.loginState.sessionType != "st_dummy") {
        this.$router.push("/mycenter")
        this.reportUserAction({
          iformat: reportDict.CLICK.PERSONAL_ENTRANCE
        })
      } else {
        this.showAppLogin({ from: "index" })
      }
    },
    getRightsInterests() {
      const { userAgent } = this
      userApi
        .getRightsInterests({ userAgent })
        .then(res => {
          this.rightsInterestsConfig = res
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
